import { useCallback } from 'react';

import type { MessageItemProps } from '@ergeon/core-components';

import type { AIAgentMessage } from '../types';

/**
 * Hook for converting AI Agent API messages to UI message format.
 */
export const useAIAgentMessages = () => {
  const convertToMessageItems = useCallback((apiMessages: AIAgentMessage[]): MessageItemProps[] => {
    return apiMessages.map((msg) => ({
      content: msg.content,
      delivered_at: msg.created_at,
      alignment: msg.role === 'user' ? 'end' : 'start',
      sender: msg.role === 'user' ? 'You' : 'AI Assistant',
      meta: msg.role === 'user' ? 'Question' : 'AI',
    }));
  }, []);

  return { convertToMessageItems };
};
